<nx-headline-box class="mb-[1.25rem]"
  appearance="underline"
  [label]="'orderModule.orderRentDetailsComponent.headline' | translate">
</nx-headline-box>

<nx-headline-box
  [label]="'orderModule.orderRentDetailsComponent.details.headline' | translate">
</nx-headline-box> 
<div class="mb-2">
  <div class="flex flex-col">
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderRentDetailsComponent.details.orderNumber' | translate">
      {{order?.number}}
    </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderRentDetailsComponent.details.type' | translate">
      {{Order.getOrderType(order?.type?.toString()) | translate}}
    </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderRentDetailsComponent.details.location' | translate">
      {{order?.location?.name}}
    </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderRentDetailsComponent.details.automaticArchive.label' | translate">
      {{(order?.archive ? 'orderModule.orderRentDetailsComponent.details.automaticArchive.true' : 'orderModule.orderRentDetailsComponent.details.automaticArchive.false') | translate}}
    </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderRentDetailsComponent.details.automaticArchive.customerNumber' | translate">
    <div class="flex items-center">
      <a [routerLink]="['/customers/customer/', order?.customer?.id ]" class="jump">
        {{order?.customer?.getFullName()? order?.customer?.getFullName() :'-'}} {{order?.customer?.number? '(' +
        order?.customer.number+ ')': ''}}
        <i [className]="'icon icon-jump-to'"></i>
      </a>
    </div>
  </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderRentDetailsComponent.details.automaticArchive.customerOrderNumber' | translate">
      {{order?.customerOrderNumber}}
    </nx-default-box>
    
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderRentDetailsComponent.details.automaticArchive.ordererName' | translate">
      {{order?.orderer?.getFullName()}}
    </nx-default-box>

    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderRentDetailsComponent.details.automaticArchive.note' | translate">
      {{order?.note}}
    </nx-default-box>
  </div>
</div>

<div *ngFor="let customAttributeSectionViewModel of order?.customAttributeSectionsViewModel; let index = index; let isLast = last" class="mb-2">
  
  <nx-headline-box
    [label]="customAttributeSectionViewModel?.label">
  </nx-headline-box> 

  <nx-default-box
    *ngFor="let customAttribute of customAttributeSectionViewModel?.customAttributes; let isLast = last"
    class="bg-white border-b border-gray"
    [label]="customAttribute?.label">
    <ng-container [ngSwitch]="customAttribute?.type">
      <ng-container *ngSwitchCase="'DATETIME'">
        {{ customAttribute?.convertedValue | date:'dd.MM.yyyy HH:mm' }}
      </ng-container>
      <ng-container *ngSwitchCase="'BOOLEAN'">
        <input type="checkbox" [checked]="customAttribute?.convertedValue"
          [disabled]="true" />
      </ng-container>
      <ng-container *ngSwitchDefault>
        {{ customAttribute?.convertedValue }}
      </ng-container>
    </ng-container>
  </nx-default-box>

</div>